// Mock data for AiWeb.se

export const services = [
  {
    id: 1,
    title: "Virtuell Administrativ assistent",
    description: "Daglig administration ex: e-posthantering, kalenderbokningar, datahantering.",
    image: "https://images.unsplash.com/photo-1746608943132-065d1d4b3c5d?w=800&q=80",
    link: "/virtuellassistans"
  },
  {
    id: 2,
    title: "AI-automatisering",
    description: "AI-chatbotar, automatiserade svar, personliga produktrekommendationer.",
    image: "https://images.unsplash.com/photo-1694903089438-bf28d4697d9a?w=800&q=80",
    link: "/aiautomatisering"
  },
  {
    id: 3,
    title: "Digital marknadsföring",
    description: "AI-genererat content, social media management, SEO-optimerade texter.",
    image: "https://images.unsplash.com/photo-1677691824304-279660ceece3?w=800&q=80",
    link: "/digitalmarknadsforing"
  },
  {
    id: 4,
    title: "AI-webbplatser & e-handel",
    description: "Hemsidor, webbshoppar, automationer med passande AI-lösningar",
    image: "https://images.unsplash.com/photo-1497366811353-6870744d04b2?w=800&q=80",
    link: "/webbplatser"
  },
  {
    id: 5,
    title: "Varumärkesprofil & Design",
    description: "Är ni nystartade eller vill uppdatera er logga och andra profilprodukter?",
    image: "https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&q=80",
    link: "/varumarke"
  },
  {
    id: 6,
    title: "Prisvärda & lång erfaren",
    description: "Erfarenhet av 25 år inom webutveckling samt ingår i ett stort nätverk med olika kompetenser kan vi med säkerhet erbjuda er en trygghet i de tjänster ni önskar hjälp med.",
    image: "https://images.pexels.com/photos/1170412/pexels-photo-1170412.jpeg?w=800&q=80",
    link: "/omoss"
  }
];

export const features = [
  {
    id: 1,
    title: "Automatiserad kundsupport",
    description: "AI-chatbots kan svara på kundfrågor dygnet runt, vilket minskar supportkostnader och ökar kundnöjdheten.",
    icon: "MessageSquare"
  },
  {
    id: 2,
    title: "Personliga produktrekommendationer",
    description: "AI kan analysera kundbeteenden och visa relevanta produkter, vilket ökar försäljningen.",
    icon: "TrendingUp"
  },
  {
    id: 3,
    title: "Datadrivna beslut",
    description: "AI kan analysera stora mängder data och ge insikter som förbättrar marknadsföring och affärsstrategier.",
    icon: "BarChart3"
  },
  {
    id: 4,
    title: "Effektivare arbetsflöden",
    description: "Automatiserade processer frigör tid så att du kan fokusera på att växa ditt företag.",
    icon: "Zap"
  }
];

export const companyInfo = {
  name: "AiWeb",
  tagline: "Webdesign Ai Solutions",
  address: "Holgersgatan 8",
  postalCode: "311 30 Falkenberg",
  email: "hej@aiweb.se",
  logoUrl: "https://static.wixstatic.com/media/40146f_4e2970803cd741cd9d9de5f8744b4e86~mv2.png"
};

export const aiAssistantInfo = {
  title: "Vill du spara tid, effektivisera ditt företag och automatisera repetitiva uppgifter?",
  description: "Med en AI-driven virtuell assistent kan du fokusera på tillväxt medan teknologin hanterar det dagliga arbetet.",
  benefits: [
    "Automatiserad kundservice – AI-chatbotar som svarar på frågor dygnet runt.",
    "Effektiv administration – E-posthantering, bokningar och datahantering.",
    "AI-optimerad marknadsföring – Automatiserade inlägg, nyhetsbrev och SEO-texter.",
    "Skräddarsydda AI-lösningar – Anpassade system för just ditt företag."
  ]
};